import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { X } from "lucide-react";
import { chapters } from "../mock";

const ChaptersMenu = ({ open, onClose }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div
      className={`fixed inset-0 z-[60] bg-brand-ink transition-opacity duration-700 ${
        open ? "opacity-100 visible pointer-events-auto" : "opacity-0 invisible pointer-events-none"
      }`}
      aria-hidden={!open}
    >
      {/* Header row */}
      <div className="flex justify-between items-center px-margin-mobile md:px-margin-desktop py-6 border-b border-ink-on-dark/10">
        <span className="font-cormorant text-[18px] tracking-[0.14em] uppercase text-ink-on-dark">
          The Kitchen Art Co.
        </span>
        <button
          onClick={onClose}
          aria-label="Close chapters"
          className="text-ink-on-dark hover:text-bright-gold-on-dark transition-colors"
        >
          <X className="h-7 w-7" />
        </button>
      </div>

      <div className="px-margin-mobile md:px-margin-desktop pt-10 md:pt-16">
        <p className="font-inter text-eyebrow uppercase tracking-[0.36em] text-bright-gold-on-dark mb-10">
          The Chapters
        </p>
        <nav className="flex flex-col">
          {chapters.map((ch, i) => {
            const active = pathname === ch.to;
            return (
              <Link
                key={ch.number}
                to={ch.to}
                onClick={onClose}
                style={{ transitionDelay: open ? `${150 + i * 60}ms` : "0ms" }}
                className={`group flex items-baseline gap-5 md:gap-8 border-t border-ink-on-dark/10 py-5 md:py-6 transition-opacity duration-700 ${
                  open ? "opacity-100" : "opacity-0"
                }`}
              >
                <span className="font-inter text-label-sm tracking-widest text-ink-on-dark/40 w-10 shrink-0">
                  {ch.number}
                </span>
                <span
                  className={`font-cormorant text-[27px] md:text-[45px] leading-none transition-colors duration-300 ${
                    active
                      ? "text-bright-gold-on-dark"
                      : "text-ink-on-dark group-hover:text-bright-gold-on-dark"
                  }`}
                >
                  {ch.label}
                </span>
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default ChaptersMenu;
